import { Observable } from 'rxjs';

import { UseCase }
from '../../base/use-case';

import { DataFileDocumentsSystemModel, FileDocumentsSystemModel }
from '../../models/configuration/file-documents-system.model';

import { ConfigurationRepository }
from '../../repositories/configuration.repository';

export class
CreateFileDocumentsSystemUseCase
implements UseCase<
DataFileDocumentsSystemModel,
FileDocumentsSystemModel
> {

    constructor(
        private repository:
        ConfigurationRepository
    ) {}

    execute(
        params: DataFileDocumentsSystemModel
    ):
    Observable<FileDocumentsSystemModel> {

        return this.repository
            .createFileDocumentsSystem(
                params
            );
    }
}